export function convertInt32ColorToRGBA(color){return`rgba(${color>>16&255},${color>>8&255},${255&color},${((color>>24&255)/255).toFixed(2)})`}